var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"contextmenu":function($event){$event.preventDefault();}}},[(_vm.src)?_c('vue-video-player',{ref:"video_block",staticClass:"vjs-custom-skin",attrs:{"options":_vm.player_options},on:{"play":_vm.unlock_params,"pause":function($event){return _vm.$emit('paused')},"ready":_vm.init,"ended":_vm.ended}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }